exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scoped-svg-icon {\n  fill: currentColor;\n  overflow: hidden;\n}\n", ""]);

// exports
